import {gql} from '@apollo/client'

export default gql`
  mutation {
    logout {
      id
      user_name
    }
  }
`;